<template>
    <span :class="['base-chip', sizeClasses[size]]">
        <slot name="leading" />
        <slot />
        <slot name="trailing" />
    </span>
</template>

<script lang="ts">
export type BaseChipSize = "2xs" | "xs" | "sm" | "md" | "compact";

interface BaseChipProps {
    size?: BaseChipSize;
}
</script>

<script setup lang="ts">
const { size = "sm" } = defineProps<BaseChipProps>();

const sizeClasses: Record<BaseChipSize, string> = {
    "2xs": "size-2xs",
    xs: "size-xs",
    sm: "size-sm",
    md: "size-md",
    compact: "size-compact",
};
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .base-chip {
        @apply inline-flex items-center gap-2 rounded-full whitespace-nowrap;
        color: var(--base-chip-text, var(--color-chip-neutral-text));
        background-color: var(--base-chip-bg, var(--color-chip-neutral-bg));
    }

    .base-chip.size-2xs {
        @apply scaffold-details-small px-2.5 h-5.5;
    }

    .base-chip.size-xs {
        @apply body-small-bold px-2.5 py-1;
    }

    .base-chip.size-sm {
        @apply body-small-bold px-4 py-2;
    }

    .base-chip.size-md {
        @apply body-small-bold px-5 py-2;
    }

    .base-chip.size-compact {
        @apply scaffold-body-small px-4 py-1;
    }

    .base-chip.size-xs:where(html[data-theme="tonal"] *),
    .base-chip.size-sm:where(html[data-theme="tonal"] *),
    .base-chip.size-md:where(html[data-theme="tonal"] *) {
        @apply scaffold-body-small;
    }
}
</style>
